import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import SEOHead from '../components/SEOHead';
import './styles/NotFound.css';

function NotFound() {
  return (
    <div className="notfound">
      <SEOHead
        title="Siden findes ikke | JBC Entreprenøren"
        description="Siden du leder efter findes ikke længere."
        url="/404"
        noindex
      />
      <Header />
      <section className="notfound-inner">
        <span className="notfound-kode">404</span>
        <h1>Siden findes ikke</h1>
        <p>Den side du leder efter er flyttet eller findes ikke længere.</p>
        <div className="notfound-links">
          <Link to="/" className="notfound-knap">Gå til forsiden</Link>
          <Link to="/kontakt" className="notfound-link">Kontakt os</Link>
        </div>
      </section>
    </div>
  );
}

export default NotFound;
